import React from 'react';
import { Clover } from 'lucide-react';

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative z-10 border-t border-white/[0.06] mt-32">
      <div className="mx-auto max-w-7xl px-6 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <Clover className="h-5 w-5 text-brand" />
            <span className="font-display font-bold text-white text-lg">Lucky<span className="text-brand">Scripts</span></span>
          </div>
          <p className="text-white/50 text-sm max-w-sm leading-relaxed">
            Premium XIM Matrix &amp; Cronus Zen scripts with instant, secure digital delivery.
          </p>
        </div>
        <div>
          <h4 className="text-white text-sm font-semibold mb-4">Legal</h4>
          <ul className="space-y-2 text-white/60 text-sm">
            <li><a data-testid="footer-privacy" href="/terms#privacy" className="hover:text-white transition-colors">Privacy Policy</a></li>
            <li><a data-testid="footer-terms" href="/terms" className="hover:text-white transition-colors">Terms of Service</a></li>
            <li><a data-testid="footer-refund" href="/terms#refund" className="hover:text-white transition-colors">Refund Policy</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white text-sm font-semibold mb-4">Connect</h4>
          <ul className="space-y-2 text-white/60 text-sm">
            <li><a data-testid="footer-contact" href="mailto:support@luckyscripts.io" className="hover:text-white transition-colors">Contact</a></li>
            <li><a data-testid="footer-discord" href="https://discord.gg/luckyscripts" target="_blank" rel="noreferrer" className="hover:text-white transition-colors">Discord</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/[0.06]">
        <div className="mx-auto max-w-7xl px-6 h-14 flex items-center justify-between text-xs text-white/40">
          <span>© {new Date().getFullYear()} Lucky Scripts. All rights reserved.</span>
          <span className="font-mono">v1.0</span>
        </div>
      </div>
    </footer>
  );
}
